import React, { useEffect, useState } from 'react'
import Avatar from 'avataaars';
import { customavatarProps } from './customavatar-interface';

const Customavatar = ({ currentAttributeName, currentAttributeValue, updateAttribute, mainAvatarValues }: customavatarProps) => {
	const [customValues, setCustomValues] = useState({})

	useEffect(() => {
		setCustomValues((prevState) => ({
			...prevState,
			...mainAvatarValues,
			[currentAttributeName]: currentAttributeValue
		}))

		// eslint-disable-next-line
	}, [currentAttributeName, currentAttributeValue])


	return (
		<div className='p-[0.3rem] cursor-pointer'
			onClick={() => {
				updateAttribute(currentAttributeValue)
			}}
		>
			<Avatar
				avatarStyle='Circle'
				className='w-[4rem] h-[4rem]'
				{
				...customValues
				}
			/>
			{/* <p className='text-center'>{currentAttributeValue}</p> */}
		</div>
	)
}

export default Customavatar